import { blockage } from "@/endpoints/dryp/blockage";
import { structure } from "@/endpoints/dryp/structure";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { BlockageStatusCard } from "./BlockageStatusCard";
import { CurrentlyBlockedCard } from "./CurrentlyBlockedCard";
import { BlockageSystemOverviewCard } from "./BlockageSystemOverviewCard";

export const BlockageSummaryMetrics = observer(() => {
	const structuresApi = useAsyncStateStore(structure.getAllStructures);
	const blockagesApi = useAsyncStateStore(blockage.getAll);

	useEffect(() => {
		structuresApi.fetch({ pageNumber: 0, pageSize: 2000 }, { isActive: true });
		blockagesApi.fetch({ pageNumber: 0, pageSize: 2000 }, undefined, { isActive: true });
	}, []);

	const structures = structuresApi.data?.items || [];
	const blockages = blockagesApi.data?.items || [];

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
			<BlockageStatusCard
				loaded={blockagesApi.loaded}
				loading={blockagesApi.loading}
				error={blockagesApi.error}
				blockages={blockages}
			/>
			<CurrentlyBlockedCard
				loaded={blockagesApi.loaded}
				loading={blockagesApi.loading}
				error={blockagesApi.error}
				blockages={blockages}
			/>
			<BlockageSystemOverviewCard
				loaded={structuresApi.loaded || blockagesApi.loaded}
				loading={structuresApi.loading || blockagesApi.loading}
				error={structuresApi.error || blockagesApi.error}
				blockages={blockages}
				structures={structures}
			/>
		</div>
	);
});
